module.exports = __webpack_public_path__ + "static/media/4.4a94fd20.jpeg";